import { SupportIcon } from "@heroicons/react/outline";
import { Activity, Book } from "lucide-react";
import Link from "next/link";
import { NavLink } from "./nav-link";

interface Category {
  title: string
}
interface Article {
  title: string
  slug: {
    current: string
  }
  categories?: Category[]
}
export type GroupedArticles = {
  [category: string]: Partial<Article>[]
}
export function SidebarNav(props: { groupedArticles: GroupedArticles }) {
  return (
    <ul>
      <li>
        <Link
          className='group flex items-center lg:text-sm lg:leading-6 mb-5 sm:mb-4 font-medium text-primary'
          href='/help-center'
        >
          <div className='mr-4 rounded-md p-1 bg-gradient-to-tr from-[#BA27BA] to-purple-800 border border-transparent'>
            <Book className='h-4 w-4 text-white' />
          </div>
          Help Center
        </Link>
      </li>
      <li>
        <Link
          className='group flex items-center lg:text-sm lg:leading-6 mb-5 sm:mb-4 font-medium text-muted-foreground hover:text-primary transition-all'
          href='/contact'
        >
          <div className='mr-4 rounded-md p-1 bg-background border border-border/50 group-hover:border-transparent transition-all group-hover:bg-gradient-to-tr from-[#BA27BA] to-purple-800'>
            <SupportIcon className='h-4 w-4 text-muted-foreground/50 group-hover:text-white' />
          </div>
          Contact Support
        </Link>
      </li>
      <li>
        <a
          className='group flex items-center lg:text-sm lg:leading-6 mb-5 sm:mb-4 font-medium text-muted-foreground hover:text-primary transition-all'
          href='https://helios.statuspage.io/'
        >
          <div className='mr-4 rounded-md p-1 bg-background border border-border/50 group-hover:border-transparent transition-all group-hover:bg-gradient-to-tr from-[#BA27BA] to-purple-800'>
            <Activity className='h-4 w-4 text-muted-foreground/50 group-hover:text-white' />
          </div>
          Status
        </a>
      </li>
      {Object.entries(props.groupedArticles).map(([category, articles]) => (
        <div key={category} className='mt-12 lg:mt-8'>
          <h5 className='mb-3.5 lg:mb-2.5 font-semibold'>{category}</h5>
          {articles.map((article) => (
            <li key={article.slug?.current}>
              <NavLink slug={article.slug?.current as string}>{article.title}</NavLink>
            </li>
          ))}
        </div>
      ))}
    </ul>
  )
}
